<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 mb-5 ps-4">
          <p class="title">
            {{ $t('footer.programs.title') }}
          </p>
          <div>
            <router-link to="/our-programs">
              {{ $t('footer.programs.pdp') }}
            </router-link>
          </div>
          <div>
            <router-link to="/our-programs">
              {{ $t('footer.programs.hybridIG') }}
            </router-link>
          </div>
          <div>
            <router-link to="/our-programs">
              {{ $t('footer.programs.holidayCamps') }}
            </router-link>
          </div>
          <br><br>
          <p class="title">
            {{ $t('footer.classes.title') }}
          </p>
          <div>
            <router-link to="/english-classes/english-class-for-5-11-years-old-kids/">
              {{ $t('footer.classes.primary') }}
            </router-link>
          </div>
          <div>
            <router-link to="/english-classes/english-class-for-12-19-years-old-kids/">
              {{ $t('footer.classes.secondary') }}
            </router-link>
          </div>
          <div>
            <router-link to="/english-classes/english-class-for-adults/">
              {{ $t('footer.classes.adult') }}
            </router-link>
          </div>
          <div>
            <router-link to="/english-classes/school-holidays-english-class/">
              {{ $t('footer.classes.creativeWriting') }}
            </router-link>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-5 mb-5 ps-4 pe-5">
          <p class="title">
            {{ $t('footer.whyUs.title') }}
          </p>
          {{ $t('footer.whyUs.description') }}
        </div>
        <div class="col-12 col-md-3 col-lg-3 mb-5 ps-4">
          <p class="title">
            {{ $t('footer.contact.title') }}
          </p>
  
          No.1-3, 2nd Floor,
          <br>Jalan SS 23/15, Taman SEA,
          <br>47400 Petaling Jaya, Selangor,
          <br>MALAYSIA
          
          <br><br>
          <a href="https://wa.me/+60173807335" target="_blank" alt="Contact us via WhatsApp">
            {{ $t('footer.contact.whatsapp') }}
          </a>
        </div>
      </div>
    </div>
    <div style="height: 20vh"></div>
    <div id="copyright" class="text-center">
      &copy; 2025 English Matters Sdn Bhd (1016133-X)
    </div>
  </footer>
  <div id="whatsApp">
    <a href="https://wa.me/+60173807335" target="_blank">
      <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/whatsapp-icon.webp" alt="Contact us via WhatsApp">
    </a>
  </div>
</template>

<style scoped>
  footer {
    background-color: #2e1aaf;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/footer.png");
    background-position: right bottom -50px;
    background-repeat: no-repeat;
    color: white;
    padding-top: 5em;
    padding-bottom: 3em;
    background-size: 1600px;
  }
  footer a {
    text-decoration: none;
    color: white;
  }
  footer a:hover {
    color: #FEB832;
  }
  p.title {
    font-weight: bold;
    padding-bottom: 20px;
  }
  #copyright {
    color: #8276cf;
  }
  #whatsApp {
    position: fixed;
    bottom: 15px;
    right: 15px;
  }
</style>